import React from 'react';
import { FormControlLabel, Radio } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  radio: {
    '&.Mui-checked': {
      color: 'rgb(19, 115, 230)',
    },
  },
});

export const ToolbarRadio = ({ value, label, ...props }) => {
  const classes = useStyles();

  return (
    <FormControlLabel
      value={value}
      control={
        <Radio
          disableRipple
          color="default"
          size="small"
          className={classes.radio}
        />
      }
      label={label}
      {...props}
    />
  );
};